import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
/* import makeRequest from '../../../../utils/makeRequest'; */
import s from './Morebtn.scss';

class Morebtn extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      moreText,
      moreLink,
      redbg,
      redBrdr,
      fullWidth,
      noArrow,
      button = false,
      onClick,
      disabled,
      ga4Data,
      smallSize,
      fWeight,
      forceTargetBlank,
      isExtraPadding,
    } = this.props;
    let WrapperComponent = Link;
    if (button) {
      WrapperComponent = 'button';
    }
    return (
      <WrapperComponent
        href={moreLink}
        className={`${s.morebtn} ${redbg ? s.redbg : ''} ${
          smallSize ? s.smallSize : ''
        }
        ${fWeight ? s.fWeight : ''}
        ${redBrdr ? s.redBrdr : ''} ${fullWidth ? s.fullWidth : ''} ${
          isExtraPadding ? s.padding20 : ''
        }  ${disabled ? s.disabled : ''}`}
        onClick={!disabled && onClick}
        ga4Data={ga4Data}
        forceTargetBlank={forceTargetBlank}
      >
        {moreText}
        {!noArrow && <i />}
      </WrapperComponent>
    );
  }
}
Morebtn.propTypes = {
  moreText: PropTypes.string,
  moreLink: PropTypes.string,
};
Morebtn.defaultProps = {
  moreText: undefined,
  moreLink: undefined,
};

export default Morebtn;
